"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EqualHousingSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var EqualHousingSVG = function EqualHousingSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.47 11.12l-13-7a1 1 0 00-.94 0l-13 7a1 1 0 10.94 1.76L5 12.06V26a2 2 0 002 2h18a2 2 0 002-2V12.06l1.53.82a1 1 0 10.94-1.76zM21 21H11a1 1 0 010-2h10a1 1 0 010 2zm0-4H11a1 1 0 010-2h10a1 1 0 010 2z"
  }));
};
exports.EqualHousingSVG = EqualHousingSVG;
EqualHousingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(EqualHousingSVG);
exports.default = _default;